<template>
<!-- 领取倒计时 -->
<div class="">
    <!-- 标题区域 -->
    <div class="" style="display: flex;margin-bottom: .5rem;">
        <div style="display: flex;align-items: center;background: linear-gradient( 270deg, #00FFC2 0%, #78F7FF 100%);
            border-radius: 6px;padding: .25rem .5rem;">
            <img src="@/assets/give-energy-clock.png" style="width: 20px;" />
            <div class=" " style="font-weight: 600;font-size: 16px;color: #027157;">限时回馈</div>
        </div>
        <div style="font-weight: 600;margin-left: .5rem;
            font-size: 24px;
            color: #08465B;">免费能量补给站</div>
    </div>

    <!-- 倒计时区域 -->
    <div class="" style="background: rgba(0,255,194,0.08);
        border-radius: 12px;">

        <!-- 倒计时 -->
        <div style="padding-top: 1rem;">
          <div class="d-flex" style="justify-content: center; align-items: center;">
           <div class="" style="font-weight: 600;
              font-size: 24px;
              color: #08465B;">
                <span class="time-item">{{hour}}</span>
                <span class="" style="padding: 0 .25rem;rgba(54,110,244,0.67)">:</span>
                <span class="time-item">{{minute}}</span>
                <span class="" style="padding: 0 .25rem;rgba(54,110,244,0.67)">:</span>
                <span class="time-item">{{second}}</span>
              </div>
          </div>
        </div>

        <!-- 数字 -->
        <div :class="{'give-done': user.giveFlag}">
          <div class="d-flex" :class="{'give-done': user.giveFlag}" style="justify-content: center; padding: .5rem 0;align-items: center;">
            <img style="width: 48px;" src="@/assets/energy-icon.png"/>
            <span class="" style="font-weight: 600;margin-left: .5rem;
              font-size: 48px;
              color: #08465B;">20000</span>
          </div>
        </div>


        <!-- 按钮 区域 -->
        <div @click.stop="giveGift" style="text-align: center;cursor: pointer;">
          <div class="invite-button" @click.stop="giveGift" :class="{'give-done': user.giveFlag}"
            style="position: relative; background: linear-gradient( 270deg, #0052D9 0%, #00FFC2 100%);text-wrap: nowrap;
                    border-radius: 20px;display: inline-flex;padding: .5rem 1rem;">
               领取今日免费能量
           </div>
        </div>

        <!-- 说明 -->
        <div style="display: flex;justify-content: center;padding: .5rem 0;
          font-weight: 400;
          font-size: 12px;
          color: rgba(0,82,217,0.5);">
          每日可领取2万免费能量，当天使用有效，次日归0需重新领取
        </div>
    </div>
</div>
</template>
<script>
import * as AccountApi from '@/api/account'
import { mapState, mapMutations} from 'vuex'
import { trim } from 'xe-utils/methods'
export default {
  name: 'GiveGiftCountDown',
  components: {

  },
  props: {
    src: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      timer: null,
      hour: 24,
      minute: 53,
      second: 53,
    }
  },
  computed: {
      ...mapState(['user', 'token']),
  },
  mounted() {
    this.startClock()
  },
  methods: {
    ...mapMutations([]),

    giveGift(){
      console.log('giveFlag', this.user.giveFlag);
      if(!this.user.id){
        return false;
      }
      if(!trim(this.token)){
        return false
      }
      if(this.user.giveFlag){
        return false;
      }
      console.log('$parent', this.$parent.$parent);
      AccountApi.giveGift().then(res => {
        this.$parent.$parent.$parent.syncUser()
      })
    },
    startClock() {
        if(this.timer){
          clearInterval(this.timer)
        }
        this.updateTime(); // 立即显示一次
        this.timer = setInterval(this.updateTime, 1000);
    },
    updateTime() {
        const now = new Date();
        // 获取小时、分钟、秒
        let hours = (23 - now.getHours()).toString().padStart(2, '0');
        const minutes = (59 - now.getMinutes()).toString().padStart(2, '0');
        const seconds = (59 - now.getSeconds()).toString().padStart(2, '0');


        // 更新显示
        this.hour = hours;
        this.minute = minutes;
        this.second = seconds;
    }
  }
}
</script>

<style scoped lang="scss">

.time-item {
  background: rgba(54,110,244,0.67);
  border-radius: 6px 6px 6px 6px;
  font-weight: 600;
  font-size: 16px;
  color: #FFFFFF;
  padding: 0.5rem;
  width: 4rem;
}
/* 鼠标悬停时的样式 */
.give-done {
  opacity: 0.8; /* 按钮本身可以稍微透明一些，以便蒙版更明显 */
}
/* 鼠标悬停时的样式 */
.invite-button:hover {
  opacity: 0.8; /* 按钮本身可以稍微透明一些，以便蒙版更明显 */
}

.invite-button::after {
  /* 蒙版层，绝对定位覆盖在按钮上 */
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: brown; /* 褐色背景 */
  opacity: 0; /* 默认透明度为0，即不显示蒙版 */
  transition: opacity 0.3s; /* 平滑过渡效果 */
}
/* 鼠标悬停时的样式 */
.give-done {
  opacity: 0.8; /* 按钮本身可以稍微透明一些，以便蒙版更明显 */
}
</style>
